import enAdmin from './locales/en/admin.json' with { type: 'json' };
import enArticles from './locales/en/articles.json' with { type: 'json' };
import enAuth from './locales/en/auth.json' with { type: 'json' };
import enBookmarks from './locales/en/bookmarks.json' with { type: 'json' };
import enCalendar from './locales/en/calendar.json' with { type: 'json' };
import enCommon from './locales/en/common.json' with { type: 'json' };
import enDashboard from './locales/en/dashboard.json' with { type: 'json' };
import enEditor from './locales/en/editor.json' with { type: 'json' };
import enFiles from './locales/en/files.json' with { type: 'json' };
import enGroups from './locales/en/groups.json' with { type: 'json' };
import enGuide from './locales/en/guide.json' with { type: 'json' };
import enMembers from './locales/en/members.json' with { type: 'json' };
import enNewsletters from './locales/en/newsletters.json' with { type: 'json' };
import enSettings from './locales/en/settings.json' with { type: 'json' };
import enSurveys from './locales/en/surveys.json' with { type: 'json' };
import zhAdmin from './locales/zh/admin.json' with { type: 'json' };
import zhArticles from './locales/zh/articles.json' with { type: 'json' };
import zhAuth from './locales/zh/auth.json' with { type: 'json' };
import zhBookmarks from './locales/zh/bookmarks.json' with { type: 'json' };
import zhCalendar from './locales/zh/calendar.json' with { type: 'json' };
import zhCommon from './locales/zh/common.json' with { type: 'json' };
import zhDashboard from './locales/zh/dashboard.json' with { type: 'json' };
import zhEditor from './locales/zh/editor.json' with { type: 'json' };
import zhFiles from './locales/zh/files.json' with { type: 'json' };
import zhGroups from './locales/zh/groups.json' with { type: 'json' };
import zhGuide from './locales/zh/guide.json' with { type: 'json' };
import zhMembers from './locales/zh/members.json' with { type: 'json' };
import zhNewsletters from './locales/zh/newsletters.json' with { type: 'json' };
import zhSettings from './locales/zh/settings.json' with { type: 'json' };
import zhSurveys from './locales/zh/surveys.json' with { type: 'json' };

export const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    articles: enArticles,
    calendar: enCalendar,
    groups: enGroups,
    guide: enGuide,
    dashboard: enDashboard,
    editor: enEditor,
    settings: enSettings,
    admin: enAdmin,
    bookmarks: enBookmarks,
    files: enFiles,
    members: enMembers,
    newsletters: enNewsletters,
    surveys: enSurveys,
  },
  zh: {
    common: zhCommon,
    auth: zhAuth,
    articles: zhArticles,
    calendar: zhCalendar,
    groups: zhGroups,
    guide: zhGuide,
    dashboard: zhDashboard,
    editor: zhEditor,
    settings: zhSettings,
    admin: zhAdmin,
    bookmarks: zhBookmarks,
    files: zhFiles,
    members: zhMembers,
    newsletters: zhNewsletters,
    surveys: zhSurveys,
  },
} as const;

export type Resources = typeof resources;
